import React, { Fragment, useState, useEffect } from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { MailIcon, LockIcon } from "components/icons";
import { useQueryClient } from "react-query";
import { useAppLogin } from 'hooks/auth/Auth';
import { PROFILE_QUERY_KEY } from 'hooks/permissions/permissions';

const REMEMBERED_EMAIL = "rememberedEmail";

const stripSpaces = (value) => (value ?? "").replace(/\s/g, "");

const VALIDATE_ON_BLUR = ["onBlur"];

const Login = () => {

  let navigate = useNavigate();
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [token, setToken] = useState(null);

  const { mutate: appLogin, data: loginData, isLoading: Loading } = useAppLogin();

  const validateMessages = {
    types: {
      email: 'Enter a valid email address!',
    }
  }

  const onFinish = ({ remember, ...credentials }) => {
    if (remember) {
      localStorage.setItem(REMEMBERED_EMAIL, credentials.email);
    } else {
      localStorage.removeItem(REMEMBERED_EMAIL);
    }
    appLogin(credentials, {
      onSuccess: (item) => {
        if (item?.statusCode === 200) {
          setToken(item?.data?.token);
        }
        else {
          message.error(item?.message)
        }
      },
      onError: (error) => {
        console.log(error)
      }
    });
  }

  useEffect(() => {
    if (token !== null) {
      if (loginData?.statusCode === 200) {
        localStorage.setItem("token", loginData?.data?.token);
        // Drop any cached profile so the previous user's permissions are never
        // used; AppLayout fetches this user's on mount.
        queryClient.removeQueries(PROFILE_QUERY_KEY);
        navigate("/dashboard");
        // setTimeout(() => window.location.reload(), 300);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const rememberedEmail = localStorage.getItem(REMEMBERED_EMAIL);

  return (
    <Fragment>
      <h2>Welcome Back</h2>
      <p>Sign in to continue to your account</p>

      <Form
        form={form}
        onFinish={onFinish}
        validateMessages={validateMessages}
        autoComplete="off"
        name="employee_info"
        layout="vertical"
        initialValues={{
          email: rememberedEmail || undefined,
          remember: !!rememberedEmail,
        }}>
        <Form.Item
          name="email"
          normalize={stripSpaces}
          validateTrigger={VALIDATE_ON_BLUR}
          rules={[{ required: true, message: "Enter your email address!" }, { type: "email" }]}>
          <Input prefix={<MailIcon />} placeholder="Email address" autoComplete="username" maxLength={254} />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: "Enter your password!" }]}>
          <Input.Password prefix={<LockIcon />} placeholder="Password" autoComplete="current-password" />
        </Form.Item>

        <div className="login-card-row">
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          <Link to={"/forgotPassword"} className="forgotPassword">Forgot password?</Link>
        </div>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={Loading} block>Sign In</Button>
        </Form.Item>
      </Form>
    </Fragment >
  );
}

export default Login;
